<template>
    <div>
        <card-header title='Conference (Legacy)' icon="fa-presentation"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Configurations" icon="fa-cubes"/>

                <conference-config-legacy
                    v-for="c in conference.configs"
                    :card="card"
                    :config="c"
                    @click="$openCard('edit-config-legacy', {confId: conference.id, configId: c.id}, card)"
                    :active="child && child.definition.component === 'edit-config-legacy' && child.props.configId == c.id"
                />
            </card-list>
        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../../http_client';
    import CardList from "../../../TIER/components/CardList";
    import SubheaderListItem from "../../../TIER/components/SubheaderListItem";
    import ConferenceConfigLegacy from "../../../components/tiles/ConferenceConfigLegacy";

    export default {
        components: {ConferenceConfigLegacy, SubheaderListItem, CardList, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: {
                    configs: []
                }
            }
        },
        methods: {
            // submit: function() {
            //     this.$emit('loading', true);
            //     http.post('courses/', this.course, {force: true}).then(response => {
            //         this.$reloadCard('courses');
            //         this.$closeCard(this.card);
            //     }).catch(err => {
            //
            //     });
            // }
            loadConference: function (force) {
                this.$emit('loading', true);

                http.get('conferences/legacy/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
        },
        mounted: function() {
            this.loadConference();
        }
    }
</script>
